export const LoginError = ({ message }) => {
  return (
    <div className="relative bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 ">
      <p className="text-red-500 text-center">{message}</p>
    </div>
  );
};
